import React from 'react';
import SharedForm from '../../components/SharedForm';
import { Input, DatePicker, Select, Switch } from 'antd';
import moment from 'moment';

const { TextArea } = Input;

export default function WechatGroupForm({ onSubmit, onSetRef, group }) {
  const { name, tag, desc, owner, school, qrCode, expressDate, isOnShow } = group || {};

  return (
    <SharedForm wrappedComponentRef={onSetRef} onSubmit={onSubmit}>
      {{
        formItems: [
          {
            title: '群组名称',
            name: 'name',
            options: {
              initialValue: name,
              rules: [{ required: true, message: '请输入群组名称' }],
            },
            render: () => <Input placeholder="请输入群组名称" />,
          },
          {
            title: '所属学校',
            name: 'school',
            options: {
              initialValue: school || 'XJTLU',
              rules: [{ required: true, message: '请选择所属学校' }],
            },
            render: () => (
              <Select placeholder="请选择所属学校">
                <Select.Option value="XJTLU">XJTLU</Select.Option>
                <Select.Option value="XJTU">XJTU</Select.Option>
                <Select.Option value="其他">其他</Select.Option>
              </Select>
            ),
          },
          {
            title: '标签',
            name: 'tag',
            options: {
              initialValue: tag ? tag.split(',').map(t => t.trim()).filter(t => t) : [],
              rules: [{ required: false }],
            },
            render: () => (
              <Select
                mode="tags"
                style={{ width: '100%' }}
                placeholder="请选择或输入标签"
                tokenSeparators={[',']}
                options={[
                  { value: '学习交流', label: '学习交流' },
                  { value: '社团活动', label: '社团活动' },
                  { value: '兴趣爱好', label: '兴趣爱好' },
                  { value: '求职招聘', label: '求职招聘' },
                  { value: '生活服务', label: '生活服务' },
                  { value: '校园资讯', label: '校园资讯' },
                ]}
              />
            ),
          },
          {
            title: '描述',
            name: 'desc',
            options: {
              initialValue: desc,
              rules: [{ required: false }],
            },
            render: () => (
              <TextArea
                rows={3}
                placeholder="请输入群组描述"
              />
            ),
          },
          {
            title: '群主',
            name: 'owner',
            options: {
              initialValue: owner,
              rules: [{ required: true, message: '请输入群主信息!' }],
            },
            render: () => <Input placeholder="请输入群主信息" />,
          },
          {
            title: '二维码链接',
            name: 'qrCode',
            options: {
              initialValue: qrCode,
              rules: [{ required: false }],
            },
            render: () => <Input placeholder="请输入二维码链接" />,
          },
          {
            title: '过期时间',
            name: 'expressDate',
            options: {
              initialValue: expressDate ? moment(expressDate) : null,
              rules: [{ required: false }],
            },
            render: () => (
              <DatePicker
                style={{ width: '100%' }}
                placeholder="请选择过期时间"
                format="YYYY-MM-DD"
              />
            ),
          },
          {
            title: '前端展示',
            name: 'isOnShow',
            options: {
              initialValue: isOnShow !== undefined ? isOnShow : true,
              valuePropName: 'checked',
              rules: [{ required: false }],
            },
            render: () => (
              <Switch
                checkedChildren="显示"
                unCheckedChildren="隐藏"
              />
            ),
          },
        ],
      }}
    </SharedForm>
  );
}